import { useEffect } from 'react';
import { useGameDispatch } from '../global-context';
import { useDragonHealthStore } from '../zustand/useDragonHealthStore';
import { useGameStatusStore } from '../zustand/useGameStatusStore';
import { GUIActions } from '../../types/game-types';
import { QuickGameDialog } from '@game-libs/quick-game-dialog';
import { useTranslation } from 'react-i18next';
import { CONFIG } from '../../config';
import { GlobalGameStore } from '@game-libs/global-game-store';

export const useVictory = () => {
  const dispatch = useGameDispatch();
  const dragonHealth = useDragonHealthStore((s) => s.dragonHealth);
  const dragonName = useGameStatusStore((s) => s.dragonName);
  const metBigDragon = useGameStatusStore((s) => s.metBigDragon);
  const won = useGameStatusStore((s) => s.won);
  const dummyKilled = useGameStatusStore((s) => s.dummyKilled);
  const { state: globalState } = GlobalGameStore();
  const { i18n } = useTranslation();

  useEffect(() => {
    const language = i18n.language;
    let unsub = () => { };

    // Tutorial win only applies to the small-dragon phase. MET_DRAGON sets dragonName/metBigDragon in
    // Zustand synchronously but dragon health is synced on the next macrotask, so one frame can have
    // bigDragon + 0 HP and would wrongly fire victory again without these guards.
    const isTutorialSmallDragonVictory =
      dragonName === 'smallDragon' &&
      !metBigDragon &&
      !won &&
      dragonHealth <= 0 &&
      globalState.currentLevel.value !== 'dummy';

    if (isTutorialSmallDragonVictory) {
      const { openDialog } = QuickGameDialog({
        pathToInkFiles: './dialogs',
        pathToSpeakerFiles: './dialogs/pictures',
        containerId: 'ui-wrapper',
      });

      dispatch({ type: GUIActions.WIN_GAME });

      if (!CONFIG.game.skipDialogs) {
        openDialog('victory', language, false);
      }
    }

    // Handle dummy death
    if (dragonHealth <= 0 && dragonName === 'dummy' && !dummyKilled) {
      const { openDialog } = QuickGameDialog({
        pathToInkFiles: './dialogs',
        pathToSpeakerFiles: './dialogs/pictures',
        containerId: 'ui-wrapper',
      });

      dispatch({ type: GUIActions.DUMMY_KILLED });

      if (!CONFIG.game.skipDialogs) {
        openDialog('dummy_death', language, false);
      }
    }

    return unsub;
  }, [dragonHealth, dragonName, metBigDragon, won, dummyKilled]);
};
